var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }